import * as React from "react";
import { cn } from "@/lib/utils";

const IconInput = React.forwardRef(
  ({ className, type, error, helperText, startIcon, endIcon, ...props }, ref) => {
    return (
      <div className="flex flex-col w-full">
        <div className={`flex items-center rounded-md border h-[40px] bg-primary-foreground ${
               error
                ? "border-red-500"
                : "border-form-border"}`}>
          {startIcon && <div className="px-1">{startIcon}</div>}

          <input
            type={type}
            className={cn(
              "font-sans flex h-full w-full  bg-transparent px-3 py-1 text-base transition-colors",
              "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
              "placeholder-[#5e758b]",
              "focus:outline-none focus:ring-0",
              // "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
              className
            )}
            onWheel={(e) => e.target.blur()}
            ref={ref}
            {...props}
          />

          {/* End Icon */}
          {endIcon && (endIcon)}
        </div>

        {helperText && (
          <span className="text-red-500 text-xs mt-1">{helperText}</span>
        )}
      </div>
    );
  }
);

IconInput.displayName = "IconInput";

export { IconInput };
